// extracted by mini-css-extract-plugin
export default {"catsContainer":"Cats_catsContainer__vvB5o","loadMore":"Cats_loadMore__OlFcy","breedsList":"Cats_breedsList__ND9JP"};